import React, { useEffect, useState } from "react";
import { Logo } from "./Logo";
import { BookDemoButton } from "./BookDemoButton";

// Small, quiet secondary link — sits next to the primary CTA without competing with it.
// href points to the production SaaS login (env-overridable). Later, replace with the real endpoint.
const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || "https://app.miseone.eu/login";

const LoginLink = ({ tone }) => (
  <a
    href={LOGIN_URL}
    data-testid="nav-login"
    className={`hidden font-body text-[13px] font-medium tracking-wide transition-opacity duration-200 hover:opacity-70 sm:inline-flex ${
      tone === "light" ? "text-white/90" : "text-[#1b1a18]/80"
    }`}
  >
    Log in
  </a>
);

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > window.innerHeight * 0.7);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-[9000] transition-colors duration-500 ${
        scrolled
          ? "border-b border-[var(--mo-line)] bg-[rgba(245,242,234,0.82)] backdrop-blur-xl"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex w-full max-w-[1600px] items-center justify-between px-6 py-4 md:px-12">
        <a
          href="#hero"
          data-testid="nav-logo"
          onClick={(e) => {
            e.preventDefault();
            window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <Logo tone={scrolled ? "ink" : "light"} />
        </a>
        <div className="flex items-center gap-6">
          <LoginLink tone={scrolled ? "ink" : "light"} />
          <BookDemoButton size="sm" testId="nav-book-demo" />
        </div>
      </div>
    </header>
  );
};
